/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum ImageDescriptionType {
    INN = 0, //Image None
    IDS = 1, //Image with Description
    IDT = 2, //Image with Description Type
    IFN = 3 //Image with Family Name
}